import {connect} from "react-redux";
import * as QuizQuestionActions from "../../store/actions/quizQuestionActions";
import * as chapterPartActions from '../../store/actions/chapterPartActions';
import EditQuizQuestions from "../../components/EditChapterPart/EditQuizQuestions";

const mapStateToProps = (state) => ({
    ...state.chapterPartInfo
});

const mapDispatchToProps = (dispatch) => ({
    onLoad: () => {
        dispatch(QuizQuestionActions.getQuizQuestions());
    },
    onQuizQuestionUpdate: (id, question, files, token) => {
        dispatch(chapterPartActions.updateQuizQuestion(id, question, files, token))
    },
    onQuizQuestionAdd: (info, token) => {
        dispatch(QuizQuestionActions.addQuizQuestion(info, token))
    }
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(EditQuizQuestions);


// WEBPACK FOOTER //
// ./src/containers/EditChapterPart/EditQuizQuestionsContainer.js